import * as THREE from "three";
import { IMetaDataObject } from "../interfaces/Misc";

export class MetadataManager 
{
	private static _metadataKeys: Set<string> = new Set<string>();
	static get metadataKeys(): string[] { return Array.from(MetadataManager._metadataKeys); }

	static clearData() : void
	{
		MetadataManager._metadataKeys.clear();
	}

	static registerEmbeddedMedataKeys(metadata: IMetaDataObject) : void
	{
		for (const key in metadata)
		{
			MetadataManager._metadataKeys.add(key);
		}
	}

	static addCustomKey(object: THREE.Object3D, key: string, value?: string) : void
	{
		if(!object.userData.metaData) object.userData.metaData = {};
		if(!object.userData.metaData[key]) object.userData.metaData[key] = { readonly: false };
		object.userData.metaData[key].value = value || "";
		
		MetadataManager._metadataKeys.add(key)
	}

	static removeCustomKey(object: THREE.Object3D, key: string) : void
	{
		if(!object.userData.metaData) return;
		if(!object.userData.metaData[key]) return;

		delete object.userData.metaData[key];
	}
}